import React, { useState } from 'react'
import { Text } from 'components/Text'
import { RatingWrapper, ReviewCardWrapper } from '../../Comments.styles'
import { Rating } from 'features/Recipes/components/Reviews/Reviews'
import { ReviewType } from 'fixtures/review'
import { useTranslation } from 'hooks/useTranslation'

type ReviewCardProps = {
  review: ReviewType
}

export const ReviewCard: React.FC<ReviewCardProps> = ({ review }) => {
  const { t } = useTranslation()

  const [readMore, setReadMore] = useState(false)

  const comment = t(review.comment)
  const maxLength = 300

  const truncatedText = (text: string) => {
    if (text.length <= maxLength) return text

    const trimmedText = text.slice(0, maxLength)
    const lastSpaceIndex = trimmedText.lastIndexOf(' ')

    return trimmedText.slice(0, lastSpaceIndex) + '...'
  }

  return (
    <ReviewCardWrapper>
      <Text
        size="body"
        color="accent-white"
        transform="uppercase"
        css={{ backgroundColor: '$secondary-300', borderRadius: '4px', padding: '4px 8px' }}
      >
        {review.tag}
      </Text>
      <Text css={{ marginBottom: '6px', marginTop: '12px' }} size="bodyExtraLarge" weight="semiBold">
        {t(review.headline)}
      </Text>
      <Text size={{ '@initial': 'body', '@bp2': 'bodyLarge' }} weight="semiBold" color="primary-700">
        — {t(review.owner)}
      </Text>
      <RatingWrapper>
        <Rating />
      </RatingWrapper>
      <Text color="accent-black" size={{ '@initial': 'body', '@bp2': 'bodyLarge' }}>
        {readMore ? comment : truncatedText(comment)}
      </Text>
      {comment.length > maxLength && !readMore && (
        <Text
          onClick={() => setReadMore(true)}
          css={{ marginTop: '$2', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
          color="accent-black"
          underline
          size={{ '@initial': 'body', '@bp2': 'bodyLarge' }}
        >
          Read More
        </Text>
      )}
    </ReviewCardWrapper>
  )
}
